/**
 * @module experience/shop/shared-browse
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export class ValidationMessageModel {
  private success: boolean;
  private message: string;

  public getSuccess(): boolean {
    return this.success;
  }
  public setSuccess(newValue: boolean): void {
    this.success = newValue;
  }
  public getMessage(): string {
    return this.message;
  }
  public setMessage(newValue: string): void {
    this.message = newValue;
  }
}
